/**
 *
 * Styles for ExpandCollapseButton
 *
 */

import styled, { css } from "styled-components";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { DhlText } from "@dhl-official/react-library";

const bubbleStyles = css`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  box-shadow: 0 3px 8px 0 var(--dui-color-gray-300);
  transition: ease-in-out 200ms box-shadow;
`;

const bubbleWithTextStyles = css`
  width: fit-content;
  padding: var(--gaq-size-space-5px) var(--dui-size-space-10x);
  border-radius: var(--dui-size-radius-md);

  &:focus,
  &:active {
    padding: 3px 18px;
    border: 2px solid var(--dui-color-black-500);
  }
`;

export const ExpandCollapseButtonBubble = styled.button`
  ${(props) =>
    props.variation === "bubbleWithText" ? bubbleWithTextStyles : bubbleStyles}
  display: flex;
  border: none;
  align-items: center;
  justify-content: center;
  background-color: var(--dui-color-white-500);

  &:hover,
  &:focus,
  &:active {
    .text {
      color: var(--dui-color-red-400);
    }

    .icon svg {
      transition: fill 0.2s ease-out;
      fill: var(--dui-color-red-400);
    }
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    ${(props) =>
      props.overflowBottomMarginDesktop ? "margin-bottom: -33px;" : ""}
  }

  button.icon {
    border-radius: 50%;

    &:hover,
    &:focus,
    &:active {
      border: 0;
    }
  }
`;

export const StyledText = styled(DhlText)`
  & > *:is(p, span) {
    transition: color 0.2s ease-out;
    display: inline-block;
    color: var(--dui-color-red-500);
    padding-right: 15px;
    padding-top: 4px;
  }
`;
